import 'css-chunksrc/client/common/calendar/styles.scss';export default {
  "calendar": "_calendar_1o4lz_1",
  "days": "_days_1o4lz_6",
  "month": "_month_1o4lz_9",
  "months": "_months_1o4lz_12",
  "year": "_year_1o4lz_15",
  "years": "_years_1o4lz_18"
};